import React from 'react';
import { Route, withRouter } from 'react-router';
import PropTypes from 'prop-types';

// you can get access to the history object's properties and the closest <Route>'s match
// via the withRouter higher-order component. withRouter will pass updated match, location,
// and history props to the wrapped component whenever it renders.

// A simple component that shows the pathname of the current location
class ListeningRoute extends React.Component {
  static propTypes = ({
    history: PropTypes.shape({
      listen: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({}).isRequired,
  })
  constructor(props) {
    super(props);
    this.state = { location: null };
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen((location) => {
      this.setState({ location });
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    return <Route {...this.props} location={this.state.location || this.props.location} />;
  }
}

export default withRouter(ListeningRoute);



// WEBPACK FOOTER //
// ./src/components/ListeningRoute.js